<template>
    <div class="presentation-tab">
        <p class="presentation-tab__search-title">{{ text.searchTitle }}</p>
        <z-input
            name="searchInput"
            :placeholder="text.searchPlaceholder"
            ref="search"
            v-model="search"
            :validateOnBlur="false"
            iconName="magnifier"
            class="presentation-tab__search"
            @input="onSearch"
        ></z-input>

        <z-tabs
            v-if="data.tabs && data.tabs.length && !search"
            size="m"
            class="presentation-tab__tabs"
            :padding="false"
            @open-tab="onTabChange"
        >
            <template v-slot:label>
                <z-tabs-label
                    v-for="(tab, index) in data.tabs"
                    :key="index"
                    :id="tab.value"
                >{{ tab.name }}</z-tabs-label>
            </template>
            <template v-slot:content>
                <z-tabs-content
                    v-for="(tab, index) in data.tabs"
                    :key="index"
                    :id="tab.value"
                    class="presentation-tab__content"
                >
                    <template v-for="(presentation, index) in yearItems">
                        <presentation-block
                            :key="presentation.code"
                            :data="{
                                link: presentation.mlDocs.link,
                                name: presentation.name,
                                size: presentation.mlDocs.size,
                                type: presentation.mlDocs.type,
                            }"
                            :style="{'order': index + 1 }"
                        />
                        <a
                            v-if="index === 1 || (index === 0 && yearItems.length <= 2)"
                            :key="index"
                            :style="{'order': index + 1 }"
                            class="presentation-tab__pdf"
                            href="/upload/iblock/1cd/Norilsk_Nickel_Environmental_Strategy_2021_ru.pdf"
                            target="_blank"
                        >
                            <z-icon
                                width="62"
                                height="36"
                                name="file/text-pdf"
                            />
                            <span class="presentation-tab__pdf-name">Актуализация корпоративной стратегии в&nbsp;области экологии и&nbsp;изменения климата</span>
                        </a>
                    </template>
                </z-tabs-content>
            </template>
        </z-tabs>
        <div v-if="search" class="presentation-tab__search-results">
            <div v-if="searchResults.length" class="presentation-tab__content">
                <presentation-block
                    v-for="(presentation, index) in searchResults"
                    :key="presentation.code"
                    :data="{
                                link: presentation.mlDocs.link,
                                name: presentation.name,
                                size: presentation.mlDocs.size,
                                type: presentation.mlDocs.type,
                            }"
                    :style="{'order': index + 1 }"
                />
            </div>
            <z-not-found v-else class="u-top-margin--xl">
                <template v-slot:image>
                    <z-image src="/images/not-found/search.svg" width="590" height="400"></z-image>
                </template>
                <template v-slot:description>
                    <z-caption size="m" decor-left decor-right><span class="u-uppercase u-xl-bold">К сожалению, ничего не найдено</span></z-caption>
                    <p class="text-size-xl u-normal">Воспользуйтесь фильтром еще раз.</p>
                </template>
            </z-not-found>
        </div>
    </div>
</template>
<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'PresentationTab',
    data () {
        return {
            data: this.$root.app.components['presentations-and-briefings'],
            text: {
                searchTitle: localize({
                    en: 'Search',
                    ru: 'Поиск'
                }),
                searchPlaceholder: localize({
                    en: 'Enter a keyword',
                    ru: 'Введите ключевое слово'
                })
            },
            search: '',
            currentYear: this.$root.app.components['presentations-and-briefings'].tabs[0].value || null,
            searchResults: []
        }
    },
    computed: {
        presentationList () {
            return this.data.items.filter(item => item.mlType.xmlId === 'presentation')
        },
        yearItems () {
            return this.presentationList.filter((item) => +item.year === +this.currentYear)
        }
    },
    methods: {
        onTabChange (tab) {
            this.currentYear = tab.replace('tabs-', '')
        },
        onSearch () {
            this.searchResults = this.presentationList.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
        }
    }
}
</script>
<style lang="scss">
.presentation-tab {
    &__search-title {
        margin-bottom: $token-spacers-3-xs;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.4;
        color: $token-colors-gray-50;
    }

    &__search {
        margin-bottom: $token-spacers-xl;
    }

    &__tabs {
        & .z-tabs-label {
            margin-right: 0;
            border-radius: 0;
        }
    }

    &__content {
        display: flex;
        flex-wrap: wrap;
        gap: $token-spacers-4-xl;
        @include breakpoint(laptop) {
            gap: $token-spacers-2-xl;
        }
        @include breakpoint(v-tablet) {
            gap: $token-spacers-m;
        }

        & .presentation-block {
            flex: 1 1 calc(100%/3 - (#{$token-spacers-4-xl} * 2 / 3));
            max-width: calc(100%/3 - (#{$token-spacers-4-xl} * 2 / 3));

            @include breakpoint(laptop) {
                flex: 1 1 calc(50% - #{$token-spacers-2-xl} / 2 );
                max-width: calc(50% - #{$token-spacers-2-xl} / 2);
            }
            @include breakpoint(v-tablet) {
                flex: 1 1 100%;
                max-width: 100%;
            }
        }
    }

    &__pdf {
        padding:$token-spacers-l $token-spacers-m;
        margin-left: auto;
        flex: 1 1 calc(100%/3 - (#{$token-spacers-4-xl} * 2 / 3));
        max-width: calc(100%/3 - (#{$token-spacers-4-xl} * 2 / 3));
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-image: url(/images/sustainability/data-center-presentation.jpg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        text-decoration: none;
        border-radius: 0 40px 0 20px;
        transition: all 0.6s ease-in-out;
        @include breakpoint(laptop) {
            order: 1 !important;
            flex: 1 1 calc(50% - #{$token-spacers-2-xl} / 2 );
            max-width: calc(50% - #{$token-spacers-2-xl} / 2);
        }
        @include breakpoint(v-tablet) {
            flex: 1 1 100%;
            max-width: 100%;
            min-height: 350px;
            order: 100!important;
        }

        & .z-icon {
            width: 62px;
            height: 36px;
            border: 1px solid white;
            padding: 8px;
            border-radius: 50px;

            & path {
                fill: #fff;
            }
        }

        &:hover {
            padding-right: calc(#{$token-spacers-m} - 8px);
            padding-left: calc(#{$token-spacers-m} + 8px);
            background-size: 120%;
        }
    }

    &__pdf-name{
        margin-top: $token-spacers-2-xs;
        display: block;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 105%;
        color: #fff;
    }
}
</style>
